import { render, staticRenderFns } from "./TotalLearningStatByPeriod.vue?vue&type=template&id=481dcde9"
import script from "./TotalLearningStatByPeriod.vue?vue&type=script&lang=js"
export * from "./TotalLearningStatByPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports